// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productDetailsBadgesStyles } from "@guestsupply/App/Widgets/ProductDetails/ProductDetailsBadges";
import { css } from "styled-components";

productDetailsBadgesStyles.productBadgesStyles = {
    customBadgesWrapper: {
        css: css`
            gap: 4px 16px;
        `,
    },
};
